import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ButtonGhost = ({ children, renderIcon, size = 'md', onClick, ...props }) => {
  const IconComponent = renderIcon;
  
  return (
    <Button size={size} onClick={onClick} {...props}>
      {children}
      {IconComponent && (
        <IconWrapper>
          <IconComponent />
        </IconWrapper>
      )}
    </Button>
  );
};

ButtonGhost.propTypes = {
  children: PropTypes.node.isRequired,
  renderIcon: PropTypes.elementType,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  onClick: PropTypes.func,
};

export default ButtonGhost;

const Button = styled.button`
  display: flex;
  min-width: 96px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0);
  background-blend-mode: multiply;
  border: none;
  cursor: pointer;
  padding: 6px 16px;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #111112;
  
  &:hover {
    background: rgba(137, 118, 147, 0.12);
  }
  
  ${props => props.size === 'sm' && `
    padding: 6px 16px;
    gap: 8px;
    font-size: 14px;
    min-width: 96px;
  `}
  
  ${props => props.size === 'lg' && `
    padding: 10px 20px;
    font-size: 16px;
    min-width: 112px;
    gap: 10px;
  `}
`;

const IconWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 10px;
  height: 6px;
  
  svg {
    width: 100%;
    height: 100%;
    fill: currentColor;
  }
`;
